module.exports = __webpack_public_path__ + "public/img/Pengelolaan Akuntansi dan Perpajakan bagi Akuntan untuk UMKM.c6e5e0fc.png";